/**
 * @description
 * Objeto statistics
 */

export class Statistics {
    public id: number = null;
    public users: string;
    public rol: string;
    public idnumber: string;
    public dates: Date;
    public dateString:string;
    public ip: string;
    public dboid: string;

    constructor() {}
  
}